import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import { Button,DatePicker,Carousel,Radio,Pagination,Tooltip,Icon,Spin,Menu,Collapse,Modal,Popover,Switch } from "ant-design-vue";
import App from "./App.vue";
import Http from "./config/http_server";
import BASE_url from "./config/config";
import Utils from "./utils/utils";
import router from "./router";
import store from "./store";
import moment from 'moment'//导入文件
import momentTZ from 'moment-timezone'//导入文件

Vue.prototype.$moment = moment;//赋值使用
Vue.prototype.$momentTZ = momentTZ;//赋值使用
// import axios from 'axios';
console.log(process.env.BASE_URL)
console.log(process.env);
console.log(process.env.NODE_ENV);

Vue.use(Button);
Vue.use(DatePicker);
Vue.use(Carousel);
Vue.use(Radio);
Vue.use(Pagination);
Vue.use(Tooltip);
Vue.use(Icon);
Vue.use(Spin);
Vue.use(Menu);
Vue.use(Collapse);
Vue.use(Popover);
Vue.use(Switch);

// Vue.prototype.$Http = new Http();
Vue.prototype.$Utils = new Utils();
Vue.prototype.$Ajax = Http
Vue.prototype.$BASE_url = BASE_url
Vue.prototype.$Modal = Modal
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
